// @ts-ignore
import _words from 'underscore.string/words';
// @ts-ignore
import _trim from 'underscore.string/trim';
import { ServiceAction } from '../types';
import { superHumanize } from '@zapier/common-utils';

export default function getActionName(
  action: ServiceAction | null | undefined,
  { hasNoVerb = false }: { hasNoVerb: boolean }
) {
  if (action == null) {
    return '';
  }

  if (hasNoVerb && action.noun) {
    // hasNoVerb == wants a noun back
    return action.noun;
  }

  let name;
  if (action.label != null) {
    name = action.label;
  } else {
    name = superHumanize(action.key ?? '');
  }

  if (hasNoVerb) {
    // clean name and split into words
    let words = _words(
      name
        .replace(/\([^)]\)/g, '') // (some text)
        .replace(/\[[^\]]\]/g, '') // [some text]
        .replace(/\s{2,}/g, ' ') // dupe white spaces
    );

    if (words.length > 1) {
      const flags = ['new', 'old', 'deprecated', 'legacy'];
      const verbs = [
        'new',
        'updated',
        'update',
        'changed',
        'delete',
        'create',
        'added',
        'add',
        'set',
        'send',
        'submit',
        'call',
        'order',
        'catch',
        'copy',
        'append',
        'moved',
        'move',
        'remove',
        'change',
        'turn',
        'start',
        'stop',
        'post',
        'record',
        'grant',
        'subscribe',
        'make',
      ];
      const articles = ['a', 'an', 'the'];
      const prepositions = ['on', 'for', 'to', 'in', 'from', 'within', 'by'];
      const conjuctions = ['and', 'or', 'but', 'nor'];
      let verbFound = -1;
      let nounFound = -1;
      let approvedWords = [] as string[];
      words.every((word: string, index: number, array: string[]) => {
        const lowerWord = word.toLowerCase();
        // No word
        if (/^[-]$/.test(word)) {
          return true;
        }
        // Articles can always be missed
        if (articles.indexOf(lowerWord) !== -1) {
          return true;
        }
        // Flags
        // 'Deprecated - Create Contact' > 'Contact',
        // 'Create Contact - Deprecated' > 'Contact',
        if (
          (index === 0 || index === array.length) &&
          flags.indexOf(lowerWord) !== -1
        ) {
          return true;
        }
        // Remove list when it has a verb
        // 'Create/Whatever Tracker' > 'Tracker'
        // 'Create Post/Copy' > 'Post/Copy'
        if (
          nounFound === -1 &&
          verbFound === -1 &&
          lowerWord
            .split(/\\|\//)
            .some((val: string) => verbs.indexOf(val) !== -1)
        ) {
          verbFound = index;
          return true;
        }
        // Remove list when it has a conjunction before finding a noun
        // 'New or Updated Spreadsheet Row' > 'Updated Spreadsheet Row'
        if (nounFound === -1 && conjuctions.indexOf(lowerWord) !== -1) {
          return true;
        }
        if (prepositions.indexOf(lowerWord) !== -1) {
          // Nothing following preposition will add meaning to noun
          // 'Create a Tracker on Google' > 'Tracker'
          if (nounFound !== -1) {
            return false;
          } else {
            // Cannot expect noun after preposition
            // 'Post to Facebook' > 'Post to Facebook'
            // 'Subscribe to Campaign' > 'Subscribe to Campaign'
            approvedWords = words;
            return false;
          }
        }
        if (nounFound === -1) {
          nounFound = index;
        }
        approvedWords.push(word);
        return true;
      });
      if (approvedWords.length > 0) {
        words = approvedWords;
      }
    }
    name = words.join(' ');
  }

  name = _trim(name);
  return name;
}
